<template>
    <!--员工档案-基本信息-->
    <div style=" width: 900px;margin:0;padding:0; font-size: 15px">
        <div v-for="(row, indey) in arr" :key="indey" style="page-break-after: always;">
            <div style="display: flex;justify-content: center;width:100%">
                <div class="title" style="font-size: 28px; line-height: 1; margin-bottom: 14px;">应聘人员履历表</div>
            </div>
            <table width="100%" height="100%" align="center" border="1" cellpadding="0" cellspacing="0"
                style="border-collapse: collapse;margin-top: 16px;table-layout:fixed;margin:0 auto;word-break:break-word">
                <tr style="line-height: 42px;text-align: center;">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        应聘岗位
                    </td>
                    <td colspan="8">{{ findLabel('recruit_post', row.recruitPost) }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        填表日期
                    </td>
                    <td colspan="8">{{ row.createdTime.split('-')[0] }}年{{ row.createdTime.split('-')[1] }}月{{ row.createdTime.split('-')[2] }}日
                    </td>
                </tr>
                <tr style="line-height: 42px;text-align: center; ">
                    <td colspan="2" style="background-color: #E7EDF8;">
                        姓名
                    </td>
                    <td colspan="2"><div style="line-height: 1.3; padding: 4px 0;">{{ row.name }}</div></td>
                    <td colspan="2" style="background-color: #E7EDF8;">
                        性别
                    </td>
                    <td colspan="2">{{ row.gender == 1 ? '男' : '女' }}</td>
                    <td colspan="2" style="background-color: #E7EDF8;">
                        民族
                    </td>
                    <td colspan="2">{{ row.nation }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        籍贯
                    </td>
                    <td colspan="4"><div style="line-height: 1.3; padding: 4px 0;">{{ row.nativePlace }}</div></td>
                    <td colspan="4" rowspan="5">
                        <div style="display: flex;justify-content: center;">
                            <img class="avatar" style="width: 90px;height: 120px; object-fit: cover;" :src="row.image" v-if="row.image" />
                        </div>
                    </td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td colspan="2" style="background-color: #E7EDF8;">
                        属相
                    </td>
                    <td colspan="2">{{ findLabel('zodiac', row.zodiac) }}</td>
                    <td colspan="2" style="background-color: #E7EDF8;">
                        身高(cm)
                    </td>
                    <td colspan="2">{{ row.height }}</td>
                    <td colspan="2" style="background-color: #E7EDF8;">
                        体重(kg)
                    </td>
                    <td colspan="2">{{ row.weight }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        出生日期
                    </td>
                    <td colspan="4">{{ row.dateOfBirth }}</td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        政治面貌
                    </td>
                    <td colspan="4">{{ findLabel('political_affiliation', row.politicalAffiliation) }}
                    </td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        联系电话
                    </td>
                    <td colspan="8">{{ row.phone }}</td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td  colspan="4" rowspan="2" style="background-color: #E7EDF8;">
                        婚姻状况
                    </td>
                    <td  colspan="4" rowspan="2" >
                        <span v-for="(item, indz) in dictionaries.marital_status" :key="indz">
                            <span v-if="item.dictId == row.maritalStatus">
                                <!-- <input type="checkbox" name="checkbox" :checked="item.dictId == row.maritalStatus" style="margin: 0 6px; color: #000;"  class="custom-checkbox"  /> -->
                                <!-- <div :class="[(item.dictId == row.maritalStatus ) ? 'my-checkbox my-checkbox-checked':'my-checkbox']"></div> -->
                                {{item.dictName }}
                            </span>
                        </span>
                    </td>
                    <td  colspan="4" style="background-color: #E7EDF8;">
                        微信号
                    </td>
                    <td  colspan="8"> {{ row.wechatNumber }}</td>
                </tr>
                <tr style="line-height: 42px;text-align: center; ">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        邮箱地址
                    </td>
                    <td colspan="8">{{ row.email }}</td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        最高学历
                    </td>
                    <td colspan="4">{{ findLabel('educational_level', row.educationalLevel) }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        期待薪资
                    </td>
                    <td colspan="4">{{ row.desiredSalary }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        可到岗日期
                    </td>
                    <td colspan="4">{{ row.availableTime }}</td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        身份证号码
                    </td>
                    <td colspan="8">{{ row.idCardNumber }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        户口性质
                    </td>
                    <td colspan="8">
                        <!-- <input type="checkbox" name="checkbox" value="checkbox" :checked="row.householdType == 2" />城镇
                        <input type="checkbox" name="checkbox" value="checkbox" :checked="row.householdType == 1" />农村 -->
                        <span v-if="row.householdType == 1">农村户口</span>
                        <span v-else-if="row.householdType == 2">城镇户口</span>
                    </td>
                </tr>
                <tr style="line-height: 42px;text-align: center; ">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        身份证详细地址
                    </td>
                    <td colspan="8">
                        <div style="line-height: 1.3; padding: 4px 0;">{{ row.householdResidenceDetail }}</div>
                    </td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        居住地详细地址
                    </td>
                    <td colspan="8">
                        <div style="line-height: 1.3; padding: 4px 0;">{{ row.currentResidenceDetail }}</div>
                    </td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td  colspan="6" style="background-color: #E7EDF8;">
                        <div style="line-height: 1.3;">是否有朋友/亲戚在本公司服务</div>
                    </td>
                    <td colspan="2">
                        <!-- <input type="checkbox" name="checkbox" value="checkbox" :checked="row.kinFlag == 1" />是
                        <input type="checkbox" name="checkbox" value="checkbox" :checked="row.kinFlag == 0" />否 -->
                        <span v-if="row.kinFlag == 1">是</span>
                        <span v-else-if="row.kinFlag == 0">否</span>
                    </td>
                    <td colspan="2" style="background-color: #E7EDF8;">
                        姓名
                    </td>
                    <td colspan="4">{{ row.kinName }}</td>
                    <td colspan="2" style="background-color: #E7EDF8;">
                        关系
                    </td>
                    <td colspan="2" width="7.5%">{{ row.kinRelationship }}</td>
                    <td colspan="2" style="background-color: #E7EDF8;">
                        部门
                    </td>
                    <td colspan="4">{{ row.kinOrganization }}</td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        爱好/专长
                    </td>
                    <td colspan="12">{{ row.hobby }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;" >
                        汽（机）车驾照
                    </td>
                    <td colspan="4">{{ findLabel('driving_license_level', row.drivingLicenseLevel) }}</td>
                </tr>

                <tr v-if="row.educationList.length != 0" style="line-height: 42px;text-align: center; background-color: #E7EDF8;">
                    <td :rowspan="row.educationList.length + 1"  colspan="4">
                        <div style="line-height: 1.3;">教育经历<br/>（从高到低）</div>
                    </td>
                    <td colspan="4">
                        起止时间
                    </td>
                    <td colspan="6" >
                        学校名称
                    </td>
                    <td colspan="4">
                        专业
                    </td>
                    <td colspan="2">
                        学历
                    </td>
                    <td colspan="4">
                        教育类型
                    </td>
                </tr>
                <tr v-for="(item, index) in row.educationList"  style="line-height: 42px;text-align: center;">
                    <template v-if="item">
                        <td colspan="4">
                            <div style="line-height: 1; padding: 4px 0; ">{{ item.startTime }}<span style="">至</span><br/>{{ item.endTime }}</div>
                        </td>
                        <td colspan="6"><div style="line-height: 1.2; padding: 4px 0;">{{ item.institutionName }}</div></td>
                        <td colspan="4"><div style="line-height: 1.2; padding: 4px 0;">{{ item.major }}</div></td>
                        <td colspan="2">{{ findLabel('educational_level', item.educationalLevel) }}</td>
                        <td colspan="4">{{ findLabel('educational_mode', item.educationalMode) }}</td>

                    </template>
                    <template v-else>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="6">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="2">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                    </template>
                </tr>



                <tr v-if="row.workRecordList.length != 0" style="line-height: 42px;text-align: center;background-color: #E7EDF8;">
                    <td colspan="4" :rowspan="row.workRecordList.length + 1">
                        <div style="line-height: 1.3;">工作经历<br/>(从近到远)</div>
                    </td>
                    <td colspan="4">
                        <div align="center">起止时间</div>
                    </td>
                    <td colspan="4" >
                        <div align="center">单位名称</div>
                    </td>
                    <td colspan="4">
                        <div style="line-height: 1.2;padding: 2px 0;">任职部门及<br/>其职位名称</div>
                    </td>
                    <td colspan="3">
                        <div align="center">离职原因</div>
                    </td>
                    <td colspan="3">
                        <div style="line-height: 1.2;padding: 2px 0;">证明人<br/>及其电话</div>
                    </td>

                    <td colspan="2">
                        <div align="center">月薪</div>
                    </td>
                </tr>
                <tr v-for="(item, index) in row.workRecordList"  style="line-height: 42px;text-align: center;">
                    <template v-if="item">
                        <td colspan="4">
                            <div style="line-height: 1;padding: 4px 0;">{{ item.startTime }}<span style="">至</span><br/>{{ item.endTime }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.company }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.organization }}<br/>{{ item.post }}</div>
                        </td>
                        <td colspan="3">{{ findLabel('resignation_reason', item.resignationReason) }}</td>
                        <td colspan="3">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.certifier }}<br/>{{ item.phone }}</div></td>
                        <td colspan="2">{{ item.salary }}</td>
                    </template>
                    <template v-else>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="3">&nbsp;</td>
                        <td colspan="3">&nbsp;</td>
                        <td colspan="2">&nbsp;</td>
                    </template>
                </tr>

                <tr v-if="row.trainingInfoList.length != 0"  style="line-height: 42px;text-align: center; background-color: #E7EDF8;">
                    <td colspan="4" :rowspan="row.trainingInfoList.length + 1">
                        <div align="center">培训经历</div>
                    </td>
                    <td colspan="4">
                        <div align="center">起止时间</div>
                    </td>
                    <td colspan="4">
                        <div align="center">培训机构</div>
                    </td>
                    <td colspan="4">
                        <div align="center">获取证书</div>
                    </td>
                    <td colspan="4">
                        <div align="center">培训方式</div>
                    </td>
                    <td colspan="4">
                        <div align="center">培训内容</div>
                    </td>
                </tr>
                <tr v-for="(item, index) in row.trainingInfoList"  style="line-height: 42px;text-align: center;">
                    <template v-if="item">
                        <td colspan="4">
                            <div style="line-height: 1;padding: 4px 0; ">{{ item.startTime }}<span style="">至</span><br/>{{ item.endTime }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.institutionName }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.certificate }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ findLabel('training_mode', item.trainingMode) }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.trainingContent }}</div>
                        </td>

                    </template>
                    <template v-else>
                        <td colspan="2">&nbsp;</td>
                        <td colspan="2">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                    </template>
                </tr>
                <tr v-if="row.familyInfoList.length != 0" style="line-height: 42px;text-align: center; background-color: #E7EDF8;">
                    <td colspan="4" :rowspan="row.familyInfoList.length + 1">
                        <div align="center">家庭成员</div>
                    </td>
                    <td colspan="4">
                        <div align="center">姓名</div>
                    </td>
                    <td colspan="4">
                        <div align="center">关系</div>
                    </td>
                    <td colspan="4">
                        <div align="center">工作单位</div>
                    </td>
                    <td colspan="4">
                        <div align="center">职务</div>
                    </td>
                    <td colspan="4">
                        <div align="center">联系电话(区+号码)</div>
                    </td>
                </tr>
                <tr v-for="(item, index) in row.familyInfoList" style="line-height: 42px;text-align: center;">
                    <template v-if="item">
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 6px 0;">{{ item.name }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 6px 0;">{{ findLabel('family_relationships', item.familyRelationships) }}</div>
                        </td>
                        <td colspan="4" >
                             <div style="line-height: 1.2;padding: 6px 0;">{{ item.company }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 6px 0;">{{ item.post }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 6px 0;">{{ item.phone }}</div>
                        </td>

                    </template>
                    <template v-else>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                    </template>
                </tr>
                <tr style="line-height: 42px;text-align: center; ">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div>紧急联系人姓名</div>
                    </td>
                    <td colspan="8">
                        <div>{{ row.emergencyContactName }}</div>
                    </td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div>紧急联系人电话</div>
                    </td>
                    <td colspan="8">
                        <div>{{ row.emergencyContactPhone }}</div>
                    </td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td colspan="6" style="background-color: #E7EDF8;">
                        <div  style="line-height: 1.2;padding: 6px 0;">原单位是否存在纠纷</div>
                    </td>
                    <td colspan="2">
                        <!-- <div align="center">
                            <input type="checkbox" name="checkbox" value="checkbox" :checked="row.dispute != ''" />是
                            <input type="checkbox" name="checkbox" value="checkbox"
                                :checked="row.dispute == '' || row.dispute == null" />否
                        </div> -->
                        <span v-if="row.dispute != ''">是</span>
                        <span v-else-if="row.dispute == '' || row.dispute == null">否</span>
                    </td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        纠纷内容
                    </td>
                    <td colspan="12">
                        <div style="line-height: 1.2;padding: 6px 0;"> {{ row.dispute }}</div>
                    </td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">招聘信息来源</div>
                    </td>
                    <td colspan="20">
                        <span v-for="(item, indz) in dictionaries.recruit_origin" :key="indz">
                            <!-- <input type="checkbox" name="checkbox" :checked="item.dictId == row.recruitOrigin" /> -->
                            <span v-if="item.dictId == row.recruitOrigin">{{ item.dictName }}</span>
                        </span>
                    </td>
                </tr>
                <tr style="line-height: 42px;text-align: center; font-size: 12px;">
                    <td colspan="24">
                        <div>应聘者需对以上填写资料真实性负责，我们会根据相关资料进行调查，如有不实，后果由应聘者自行承担</div>
                    </td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td rowspan="2" colspan="16">
                        <div align="center" style="color:#999999;">请各位应聘者确保以上信息真实有效，确认无误请签字</div>
                    </td>
                    <td colspan="2">姓名：</td>
                    <td colspan="6">&nbsp;</td>
                </tr>
                <tr style="line-height: 42px;text-align: center;">
                    <td colspan="2">日期：</td>
                    <td colspan="6">&nbsp;</td>
                </tr>
            </table>
            <div style="padding-top: 20px;page-break-before: always; /* 在这个元素之前开始新的一页 */">
                <table width="100%" height="100%" border="1" cellpadding="0" cellspacing="0"
                    style="border-collapse: collapse;table-layout:fixed;word-break:break-word;">
                    <tr>
                        <td colspan="4" rowspan="3" style="text-align: center; background-color: #E7EDF8; height: 335px;">
                            <div>行政人事意见</div>
                        </td>
                        <td colspan="20" style="vertical-align:top; padding: 8px 6px;">
                            <div>优势：</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>不足：</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="20" style="line-height: 42px;">
                            <div style="display: flex;padding:8px 6px">
                                <div style="padding-right: 6px;">结论：</div>
                                <input type="checkbox" name="checkbox" value="checkbox" />
                                <div style="margin:0 24px 0 4px;">通知</div>
                                <input type="checkbox" name="checkbox2" value="checkbox" />
                                <div style="margin:0 24px 0 4px;">不通知</div>
                                <input type="checkbox" name="checkbox3" value="checkbox" />
                                <div style="margin:0 0 0 4px;">待定</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="10" style="line-height: 42px;">
                            <div style="padding: 8px 6px;">签名：</div>
                        </td>
                        <td colspan="10" >
                            <div style="padding: 8px 6px;">日期：</div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4" rowspan="3" style="text-align: center; background-color: #E7EDF8; height: 335px;">
                            <div style="line-height: 1.2;">用人部门面试意见<br/>(必填)</div>
                        </td>
                        <td colspan="20" style="vertical-align:top; padding: 8px 6px;">
                            <div>优势：</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>不足：</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="10" style="line-height: 42px;">
                            <div style="display: flex;padding:8px 6px">
                                <div style="padding-right: 6px;">结论：</div>
                                <input type="checkbox" name="checkbox" value="checkbox" />
                                <div style="margin:0 24px 0 4px;">通知</div>
                                <input type="checkbox" name="checkbox2" value="checkbox" />
                                <div style="margin:0 24px 0 4px;">不通知</div>
                                <input type="checkbox" name="checkbox3" value="checkbox" />
                                <div style="margin:0 0 0 4px;">待定</div>
                            </div>
                        </td>
                        <td colspan="10" >
                            <div style="display: flex;padding:8px 6px">
                                <div style="padding-right: 6px;">简历是否合格：</div>
                                <input type="checkbox" name="checkbox" value="checkbox" />
                                <div style="margin:0 24px 0 4px;">是</div>
                                <input type="checkbox" name="checkbox2" value="checkbox" />
                                <div style="margin:0 0 0 4px;">否</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="10" style="line-height: 42px;">
                            <div style="padding: 8px 6px;">签名：</div>
                        </td>
                        <td colspan="10" >
                            <div style="padding: 8px 6px;">日期：</div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4" rowspan="3" style="text-align: center; background-color: #E7EDF8; height: 335px;">
                            <div>总经理批示</div>
                        </td>
                        <td colspan="20" style="vertical-align:top; padding: 8px 6px;">
                            <div>优势：</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>不足：</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="20" style="line-height: 42px;">
                            <div style="display: flex;padding:8px 6px">
                                <div style="padding-right: 6px;">结论：</div>
                                <input type="checkbox" name="checkbox" value="checkbox" />
                                <div style="margin:0 24px 0 4px;">通知</div>
                                <input type="checkbox" name="checkbox2" value="checkbox" />
                                <div style="margin:0 24px 0 4px;">不通知</div>
                                <input type="checkbox" name="checkbox3" value="checkbox" />
                                <div style="margin:0 0 0 4px;">待定</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="10" style="line-height: 42px;">
                            <div style="padding: 8px 6px;">签名：</div>
                        </td>
                        <td colspan="10" >
                            <div style="padding: 8px 6px;">日期：</div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'baseStaffRecordDetail',
    props: {
        currentRow: {
            type: Array,
            default() {
                return []
            }
        },
    },
    components: {

    },
    created() {
        this.dictionaries = this.fmObjToArr(JSON.parse(sessionStorage.getItem('dictionaries')))
        this.dict('zodiac')
        this.dict('recruit_post')
        this.dict('recruit_origin')
        this.dict('job_nature')
        this.dict('recruit_type')

        this.dict('educational_type')
        this.dict('marital_status')
        this.dict('driving_license_level')
        this.dict('political_affiliation')
        this.dict('household_type')
        this.dict('resignation_reason')
        this.dict('educational_mode')
        this.dict('educational_level')
        this.dict('family_relationships')
        this.dict('training_mode')
    },
    mounted() {

    },
    watch: {
        currentRow(val) {
            val.forEach((item) => {
                if (item.familyInfoList) {
                    item.familyInfoList.forEach((itm) => {
                        if (itm.emergencyFlag == 1) {
                            item.jName = itm.name
                            item.jPhone = itm.phone
                        } else {
                            item.jName = null
                            item.jPhone = null
                        }

                    })
                }
            })
            this.arr = val
            console.log(this.arr)
        }
    },
    data() {
        return {
            // row: {},
            result: "",
            sex: ['', '男', '女'],
            arr: [

            ],
            dictionaries: {

            }
        }
    },
    methods: {
        dict(val) {
            this.dictionaries.forEach((item) => {
                console.log(item)
                if (item.value == val) {
                    this.dictionaries[val] = item.label
                }
            })
        },
        fmObjToArr(data) {
            let arr = []
            for (let key in data) {
                let tem = []
                for (let i in data[key]) {
                    let obj = {
                        dictId: i,
                        dictName: data[key][i]

                    }
                    tem.push(obj)
                }
                arr.push({
                    label: tem, // label 字段
                    value: key   // value字段
                })
            }
            console.log(arr)
            return arr
        },
        findLabel(label, val) {
            let dictName = ''
            return dictName = this.dictionaries[label].find(item => item.dictId == val).dictName
            // console.log(this.dictionaries[label])
            // this.dictionaries[label].forEach(item => {
            //     if (item.dictId == val) {
            //         console.log(item.dictName)
            //         dictName = item.dictName
            //         return dictName
            //     } else {
            //         return dictName = ''
            //     }
            // })
            // return dictName
        },
    }
}
</script>
